// extracted by mini-css-extract-plugin
module.exports = {"PageNotFound":"styles_PageNotFound__2yoXj"};